'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = reducers;
exports.initialize = initialize;
exports.destory = destory;
exports.createPagePermission = createPagePermission;
exports.fetchUserPermissions = fetchUserPermissions;

var _lodash = require('lodash');

var _index = require('../actions/index');

var _utils = require('../utils');

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _humps = require('humps');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var apiPath = 'Authorization/GetAuthorized';

// 跟著promiseMiddleware的promiseTypeSuffixes
// 若suffix有變動這邊要一併修改
var REQUEST = 'REQUEST';
var SUCCESS = 'SUCCESS';
var FAIL = 'FAIL';

var isUserPermissionAction = function isUserPermissionAction(action) {
  return action && action.type && action.type.indexOf(_index.prefix) > -1;
};

var filterPermissions = function filterPermissions(config, allPermissions) {
  var functionCodes = Object.keys(config.functionCodes).map(function (functionCode) {
    return functionCode.toLowerCase();
  });
  var actionCodes = Object.keys(config.actionCodes).map(function (actionCode) {
    return actionCode.toLowerCase();
  });

  var permissions = allPermissions.filter(function (permission) {
    var parentFunctionCode = permission.parentFunctionCode && permission.parentFunctionCode.toLowerCase();
    var functionCode = permission.functionCode && permission.functionCode.toLowerCase();
    var actionCode = permission.actionCode && permission.actionCode.toLowerCase();

    var matchParentFunctionCode = functionCodes.indexOf(parentFunctionCode) !== -1;
    var matchFunctionCode = functionCodes.indexOf(functionCode) !== -1;
    var matchActionCode = actionCodes.indexOf(actionCode) !== -1 || permission.actionCode === 'Default';
    return (matchParentFunctionCode || matchFunctionCode) && matchActionCode;
  });
  return permissions;
};

var initialState = {
  allPermissions: null // cache所有permission
};

// 取得、更新permission
var fetchReducer = function fetchReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _index.UPDATE_USER_PERMISSIONS + '_' + REQUEST:
    case _index.UPDATE_USER_PERMISSIONS + '_' + FAIL:
    case _index.FETCH_USER_PERMISSIONS + '_' + REQUEST:
    case _index.FETCH_USER_PERMISSIONS + '_' + FAIL:
      {
        return Object.assign({}, state, { allPermissions: null });
      }
    case _index.UPDATE_USER_PERMISSIONS + '_' + SUCCESS:
    case _index.FETCH_USER_PERMISSIONS + '_' + SUCCESS:
      {
        var apiResponse = action.response && action.response.data;
        var axiosResponse = action.payload && action.payload.data && action.payload.data.data;
        var allPermissions = apiResponse || axiosResponse;

        if (action.type === _index.UPDATE_USER_PERMISSIONS + '_' + SUCCESS) {
          var newState = {};
          var pages = Object.keys(state);
          pages.map(function (name) {
            if (name === 'allPermissions') {
              newState.allPermissions = allPermissions;
              return name;
            }
            var pageData = state[name];
            var permissions = filterPermissions(pageData, allPermissions);

            newState[name] = Object.assign({}, pageData, { permissions: permissions });
            return name;
          });

          return newState;
        }

        return Object.assign({}, state, { allPermissions: allPermissions });
      }
    default:
      return state;
  }
};

// 建立各個頁面permission
var createReducer = function createReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _index.INITIALIZE:
      {
        var _action$meta = action.meta,
            initialFunctionCode = _action$meta.functionCode,
            initialActionCode = _action$meta.actionCode,
            initialFunctionCodes = _action$meta.functionCodes,
            initialPropNamespace = _action$meta.propNamespace,
            initialPermissionName = _action$meta.permission;
        // 設定propNamespace

        var propNamespace = initialPropNamespace || 'permission';

        // 將function和action code轉成物件字串提供使用
        var functionCodes = (0, _utils.toArray)(initialFunctionCode);
        var actionCodes = (0, _utils.toArray)(initialActionCode);
        if (initialFunctionCodes) {
          initialFunctionCodes.forEach(function (item) {
            var actionCodeArray = (0, _utils.toArray)(item.actionCode);
            functionCodes.push(item.functionCode);
            actionCodes = actionCodes.concat(actionCodeArray);
          });
        }
        functionCodes = (0, _lodash.uniq)(functionCodes);
        actionCodes = (0, _lodash.uniq)(actionCodes);

        return Object.assign({}, state, _defineProperty({}, initialPermissionName, {
          propNamespace: propNamespace,
          isInitialized: true,
          functionCodes: (0, _lodash.keyBy)(functionCodes),
          actionCodes: (0, _lodash.keyBy)(actionCodes),
          permissions: null
        }));
      }
    case _index.CREATE_PAGE_PERMISSION:
      {
        var permissionName = action.meta.permission;

        var permissions = filterPermissions(state[permissionName], state.allPermissions);

        return Object.assign({}, state, _defineProperty({}, permissionName, Object.assign({}, state[permissionName], { permissions: permissions })));
      }
    case _index.DESTORY:
      {
        var _permissionName = action.meta.permission;

        var newState = (0, _lodash.cloneDeep)(state);
        delete newState[_permissionName];
        return newState;
      }
    default:
      return state;
  }
};

function reducers() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  var permission = action && action.meta && action.meta.permission;
  if (!permission && !isUserPermissionAction(action)) {
    return state;
  }
  if (!permission) {
    return fetchReducer(state, action);
  }
  return createReducer(state, action);
}

function initialize(config) {
  return {
    type: _index.INITIALIZE,
    meta: config
  };
}

function destory(permission) {
  return {
    type: _index.DESTORY,
    meta: { permission: permission }
  };
}

function createPagePermission(permission) {
  return {
    type: _index.CREATE_PAGE_PERMISSION,
    meta: { permission: permission }
  };
}
function fetchUserPermissions(baseURL, params) {
  return {
    type: _index.START_USER_PERMISSIONS_TIMER,
    payload: {
      type: _index.FETCH_USER_PERMISSIONS,
      payload: (0, _axios2.default)({
        method: 'get',
        url: apiPath,
        baseURL: baseURL,
        params: params,
        withCredentials: true,
        transformResponse: function transformResponse(data, header) {
          if (header['content-type'].indexOf('application/json') > -1) {
            if ((0, _utils.isJsonString)(data)) {
              return (0, _humps.camelizeKeys)(JSON.parse(data));
            }
            return (0, _humps.camelizeKeys)(data);
          }
          return data;
        },
        transformRequest: function transformRequest(data) {
          if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' && !(data instanceof FormData)) {
            return JSON.stringify((0, _humps.pascalizeKeys)(data));
          }
          return data;
        }
      })
    }
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/@mayo/user-permissions/lib/reducers/index.js
 ** module id = 278
 ** module chunks = 0
 **/